//#region import
import React, { useContext, useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import Panel0 from './Panel0';
import Panel1 from './Panel1';
import Panel2 from './Panel2';
import Panel3 from './Panel3';
import Panel4 from './Panel4';
import Panel5 from './Panel5';
import Panel6 from './Panel6';
import Panel7 from './Panel7';
import Panel8 from './Panel8';
import Panel9 from './Panel9';
import Panel10 from './Panel10';
import Panel11 from './Panel11';
import Panel12 from './Panel12';
import { ProjectContext } from '../ProjectRequestFrom';
import { BtnExample } from 'components/Button/ButtonAll';
import { I18n } from 'utilities/utilities';
import { I18NextNs } from 'enum/enum';
import { downloadFile } from 'components/Input/UploadFile';
//#endregion

const RequestPanel = () => {
    const { 
        nProjectID,
        setnProjectID,
        isFastTrack,
        isPermission,
        ObjProjectRequest,
        arrisEditPanel,
        setarrisEditPanel,
        nStatusID,
        ObjExampleFile,
        ObjStepFlowProject,
        isModeSecretary,
    } = useContext(ProjectContext);

    // useEffect(() => {
    //     window.scrollTo(0, 0);
    //     // SetProjectRequestPanel();
    // }, []);

    // const SetProjectRequestPanel = () => {
        
    // }

    const onExample = () => {
        // โหลดไฟล์เปิดมาอีกแท็บ
        // sExampleFile โหลดไฟล์เปิดมาอีกแท็บ // ตัวอย่างการกรอกข้อมูล กท.1 // ObjExampleFile

        if(ObjExampleFile?.sPathFile && ObjExampleFile?.sFileName) {
            // downloadFile(ObjExampleFile?.sPathFile, ObjExampleFile?.sFileName);            
            window.open(ObjExampleFile?.sPathFile, "_blank", 'noopener,noreferrer');
        }
    }

    return (
        <Grid item xs={12} md={12} container spacing={2} style={{ padding: '2%', paddingBottom: '1%', }}>
            <Grid item xs={12} md={12} container spacing={1} justifyContent="end" style={{ paddingBottom: '1%', }}>
                <BtnExample id={"BtnExample_Panel"} txt={"ตัวอย่างการกรอกข้อมูล กท.1"} onClick={onExample} />
            </Grid> 
            <Grid item xs={12} md={12}>
                <Panel0 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel1 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel2 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel3 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel4 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel5 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel6 />  
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel7 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel8 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel9 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel10 />
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel11 /> 
            </Grid>
            <Grid item xs={12} md={12}>
                <Panel12 />
            </Grid>
        </Grid>
    )
}
export default RequestPanel;